"use client";
import * as React from "react";
const SvgNotificationsRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 13 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.5 16a1.7 1.7 0 0 0 1.72-1.64H4.79c0 .9.76 1.64 1.71 1.64m5.14-4.92v-4.1c0-2.53-1.4-4.63-3.85-5.2v-.55C7.79.55 7.2 0 6.5 0S5.22.55 5.22 1.23v.56c-2.46.56-3.86 2.66-3.86 5.18v4.1l-1.1 1.06c-.55.52-.17 1.4.6 1.4h11.28c.76 0 1.15-.88.6-1.4z" }));
export {
  SvgNotificationsRound as default
};
